import { Input } from 'antd';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { TableCellEntityMode } from 'entities/TableCell';
import { TableInputNumberController } from 'stores/common/TableController';
import { getDecimalRegex, getDecimalSeparator } from 'utils/number/locale';

import { TableControllerProps } from '../types';

import s from './InputNumberController.module.scss';

const InputNumberController: React.FC<
  TableControllerProps<TableInputNumberController>
> = ({ record, className, params }) => {
  const [isFocused, setIsFocused] = React.useState(false);

  const handleFocus = React.useCallback(() => setIsFocused(true), []);
  const handleBlur = React.useCallback(() => setIsFocused(false), []);

  const handleChange = React.useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      let value = e.currentTarget.value;
      const sep = getDecimalSeparator();

      /* Убираем лидирующий ноль для правильного отображения числа */
      /* Но не удаляем ноль после минуса (например, -0.5 или -0,5) */
      if (value.startsWith('0') && !value.startsWith(`0${sep}`) && value !== '0') {
        value = value.slice(1);
      }
      if (value.startsWith('-0') && !value.startsWith(`-0${sep}`) && value !== '-0') {
        value = '-' + value.slice(2);
      }

      if (getDecimalRegex().test(value)) {
        record.setValue(value);
      }
    },
    [record]
  );

  const controllerDisabled = params?.mode === TableCellEntityMode.disabled;

  const isNegative = record.controllerValue?.startsWith('-') && record.controllerValue !== '-';

  return (
    <Input
      value={isFocused ? record.controllerValue : record.formattedDisplayValue}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onChange={handleChange}
      className={cn(className, {
        [s.negative]: isNegative,
      })}
      disabled={controllerDisabled}
    />
  );
};

export default observer(InputNumberController);
